import { LibbyFetchDAO } from '../LibbyFetchDAO';

export class GoalProductDAO extends LibbyFetchDAO {
  constructor() {
    super('ster_goal_product', 'goal_product_id');
  }
}
